export type PaginationItem = {
  slug: string;
  title: string;
  imagePath?: string;
};

export type PaginationArgs = {
  items: PaginationItem[];
  pathname: string;
  slug: string;
};

export function paginate(args: PaginationArgs) {
  const { items, slug, pathname } = args;

  const PREV_BTN_SELECTOR = ".pagination__prev-btn";
  const NEXT_BTN_SELECTOR = ".pagination__next-btn";
  const NEXT_BTN_CONTENT_SELECTOR = ".pagination__next-btn__content";
  const PREV_BTN_CONTENT_SELECTOR = ".pagination__prev-btn__content";

  const currentIndex = items.findIndex((item) => item.slug === slug);
  const nextBtn: HTMLAnchorElement | null =
    document.querySelector(NEXT_BTN_SELECTOR);
  const prevBtn: HTMLAnchorElement | null =
    document.querySelector(PREV_BTN_SELECTOR);
  const nextBtnContent = document.querySelector(NEXT_BTN_CONTENT_SELECTOR);
  const prevBtnContent = document.querySelector(PREV_BTN_CONTENT_SELECTOR);

  const elements = nextBtn && prevBtn && nextBtnContent && prevBtnContent;

  if (currentIndex === 0 && items.length > 1 && elements) {
    const nextItem = items[currentIndex + 1];
    hide();
    update(nextItem, nextBtn, nextBtnContent);
  } else if (
    currentIndex > 0 &&
    currentIndex !== items.length - 1 &&
    elements
  ) {
    const prevItem = items[currentIndex - 1];
    const nextItem = items[currentIndex + 1];
    hide();
    update(prevItem, prevBtn, prevBtnContent);
    update(nextItem, nextBtn, nextBtnContent);
  } else if (
    currentIndex === items.length - 1 &&
    items.length > 1 &&
    elements
  ) {
    const prevItem = items[currentIndex - 1];
    hide();
    update(prevItem, prevBtn, prevBtnContent);
  } else {
    hide();
  }

  function hide() {
    nextBtn?.classList.add("hidden");
    prevBtn?.classList.add("hidden");
  }

  function update(
    item: PaginationItem,
    btnEl: HTMLAnchorElement | null,
    contentEl: Element | null,
  ) {
    const img = btnEl?.querySelector("img");

    if (btnEl && contentEl) {
      btnEl.href = `${pathname}/${item.slug}`;
      contentEl.innerHTML = item.title;
      btnEl.classList.remove("hidden");
    }

    if (item.imagePath && img) {
      img.src = item.imagePath;
      img.classList.remove("hidden");
      return;
    }

    if (!item.imagePath && img) {
      img.src = "";
      img.classList.add("hidden");
    }
  }
}
